import { createReducer, on } from '@ngrx/store';
import * as TerminalOperatorManagementActions from './terminal-operator-management.actions';
import {
  handleClear,
  handleFailure,
  handleRequest,
  handleSuccess,
} from '../../../../shared/ngrx-factory/factory.reducer';
import { initialState } from './terminal-operator-management.state';

export const terminalOperatorManagementReducer = createReducer(
  initialState,

  on(TerminalOperatorManagementActions.TerminalOperatorDashboardActions.request, (state) =>
    handleRequest(state, 'terminalOperatorDashboard'),
  ),
  on(
    TerminalOperatorManagementActions.TerminalOperatorDashboardActions.success,
    (state, { response }) => handleSuccess(state, 'terminalOperatorDashboard', response),
  ),
  on(
    TerminalOperatorManagementActions.TerminalOperatorDashboardActions.failure,
    (state, { error }) => handleFailure(state, 'terminalOperatorDashboard', error),
  ),
  on(TerminalOperatorManagementActions.TerminalOperatorDashboardActions.clearState, (state) =>
    handleClear(state, 'terminalOperatorDashboard'),
  ),

  on(TerminalOperatorManagementActions.TerminalsActions.request, (state) =>
    handleRequest(state, 'terminals'),
  ),
  on(TerminalOperatorManagementActions.TerminalsActions.success, (state, { response }) =>
    handleSuccess(state, 'terminals', response),
  ),
  on(TerminalOperatorManagementActions.TerminalsActions.failure, (state, { error }) =>
    handleFailure(state, 'terminals', error),
  ),
  on(TerminalOperatorManagementActions.TerminalsActions.clearState, (state) =>
    handleClear(state, 'terminals'),
  ),

  on(TerminalOperatorManagementActions.TerminalsByCompanyActions.request, (state) =>
    handleRequest(state, 'terminalsByCompany'),
  ),
  on(TerminalOperatorManagementActions.TerminalsByCompanyActions.success, (state, { response }) =>
    handleSuccess(state, 'terminalsByCompany', response),
  ),
  on(TerminalOperatorManagementActions.TerminalsByCompanyActions.failure, (state, { error }) =>
    handleFailure(state, 'terminalsByCompany', error),
  ),
  on(TerminalOperatorManagementActions.TerminalsByCompanyActions.clearState, (state) =>
    handleClear(state, 'terminalsByCompany'),
  ),

  on(TerminalOperatorManagementActions.DeleteTerminalRequestActions.request, (state) =>
    handleRequest(state, 'deleteTerminalRequest'),
  ),
  on(
    TerminalOperatorManagementActions.DeleteTerminalRequestActions.success,
    (state, { response }) => handleSuccess(state, 'deleteTerminalRequest', response),
  ),
  on(
    TerminalOperatorManagementActions.DeleteTerminalRequestActions.failure,
    (state, { error }) => handleFailure(state, 'deleteTerminalRequest', error),
  ),
  on(TerminalOperatorManagementActions.DeleteTerminalRequestActions.clearState, (state) =>
    handleClear(state, 'deleteTerminalRequest'),
  ),

  on(TerminalOperatorManagementActions.ProductUsageActions.request, (state) =>
    handleRequest(state, 'productUsages'),
  ),
  on(TerminalOperatorManagementActions.ProductUsageActions.success, (state, { response }) =>
    handleSuccess(state, 'productUsages', response),
  ),
  on(TerminalOperatorManagementActions.ProductUsageActions.failure, (state, { error }) =>
    handleFailure(state, 'productUsages', error),
  ),
  on(TerminalOperatorManagementActions.ProductUsageActions.clearState, (state) =>
    handleClear(state, 'productUsages'),
  ),

  on(TerminalOperatorManagementActions.UnitOfMeasureActions.request, (state) =>
    handleRequest(state, 'unitOfMeasures'),
  ),
  on(TerminalOperatorManagementActions.UnitOfMeasureActions.success, (state, { response }) =>
    handleSuccess(state, 'unitOfMeasures', response),
  ),
  on(TerminalOperatorManagementActions.UnitOfMeasureActions.failure, (state, { error }) =>
    handleFailure(state, 'unitOfMeasures', error),
  ),
  on(TerminalOperatorManagementActions.UnitOfMeasureActions.clearState, (state) =>
    handleClear(state, 'unitOfMeasures'),
  ),

  on(TerminalOperatorManagementActions.TerminalStockReportsActions.request, (state) =>
    handleRequest(state, 'terminalStockReports'),
  ),
  on(TerminalOperatorManagementActions.TerminalStockReportsActions.success, (state, { response }) =>
    handleSuccess(state, 'terminalStockReports', response),
  ),
  on(TerminalOperatorManagementActions.TerminalStockReportsActions.failure, (state, { error }) =>
    handleFailure(state, 'terminalStockReports', error),
  ),
  on(TerminalOperatorManagementActions.TerminalStockReportsActions.clearState, (state) =>
    handleClear(state, 'terminalStockReports'),
  ),

  on(TerminalOperatorManagementActions.TerminalDailyStockActions.request, (state) =>
    handleRequest(state, 'terminalDailyStock'),
  ),
  on(TerminalOperatorManagementActions.TerminalDailyStockActions.success, (state, { response }) =>
    handleSuccess(state, 'terminalDailyStock', response),
  ),
  on(TerminalOperatorManagementActions.TerminalDailyStockActions.failure, (state, { error }) =>
    handleFailure(state, 'terminalDailyStock', error),
  ),
  on(TerminalOperatorManagementActions.TerminalDailyStockActions.clearState, (state) =>
    handleClear(state, 'terminalDailyStock'),
  ),

  on(TerminalOperatorManagementActions.TerminalStockSubmitActions.request, (state) =>
    handleRequest(state, 'terminalStockSubmit'),
  ),
  on(TerminalOperatorManagementActions.TerminalStockSubmitActions.success, (state, { response }) =>
    handleSuccess(state, 'terminalStockSubmit', response),
  ),
  on(TerminalOperatorManagementActions.TerminalStockSubmitActions.failure, (state, { error }) =>
    handleFailure(state, 'terminalStockSubmit', error),
  ),
  on(TerminalOperatorManagementActions.TerminalStockSubmitActions.clearState, (state) =>
    handleClear(state, 'terminalStockSubmit'),
  ),

  on(TerminalOperatorManagementActions.TerminalTankStockSubmitActions.request, (state) =>
    handleRequest(state, 'terminalTankStockSubmit'),
  ),
  on(
    TerminalOperatorManagementActions.TerminalTankStockSubmitActions.success,
    (state, { response }) => handleSuccess(state, 'terminalTankStockSubmit', response),
  ),
  on(TerminalOperatorManagementActions.TerminalTankStockSubmitActions.failure, (state, { error }) =>
    handleFailure(state, 'terminalTankStockSubmit', error),
  ),
  on(TerminalOperatorManagementActions.TerminalTankStockSubmitActions.clearState, (state) =>
    handleClear(state, 'terminalTankStockSubmit'),
  ),

  on(TerminalOperatorManagementActions.TerminalDashboardSummaryActions.request, (state) =>
    handleRequest(state, 'terminalDailySummary'),
  ),
  on(
    TerminalOperatorManagementActions.TerminalDashboardSummaryActions.success,
    (state, { response }) => handleSuccess(state, 'terminalDailySummary', response),
  ),
  on(
    TerminalOperatorManagementActions.TerminalDashboardSummaryActions.failure,
    (state, { error }) => handleFailure(state, 'terminalDailySummary', error),
  ),
  on(TerminalOperatorManagementActions.TerminalDashboardSummaryActions.clearState, (state) =>
    handleClear(state, 'terminalDailySummary'),
  ),

  on(TerminalOperatorManagementActions.TerminalTankStatusUpdateActions.request, (state) =>
    handleRequest(state, 'terminalTankStatusUpdate'),
  ),
  on(
    TerminalOperatorManagementActions.TerminalTankStatusUpdateActions.success,
    (state, { response }) => handleSuccess(state, 'terminalTankStatusUpdate', response),
  ),
  on(
    TerminalOperatorManagementActions.TerminalTankStatusUpdateActions.failure,
    (state, { error }) => handleFailure(state, 'terminalTankStatusUpdate', error),
  ),
  on(TerminalOperatorManagementActions.TerminalTankStatusUpdateActions.clearState, (state) =>
    handleClear(state, 'terminalTankStatusUpdate'),
  ),

  on(TerminalOperatorManagementActions.TerminalStockStatusUpdateActions.request, (state) =>
    handleRequest(state, 'terminalStockStatusUpdate'),
  ),
  on(
    TerminalOperatorManagementActions.TerminalStockStatusUpdateActions.success,
    (state, { response }) => handleSuccess(state, 'terminalStockStatusUpdate', response),
  ),
  on(
    TerminalOperatorManagementActions.TerminalStockStatusUpdateActions.failure,
    (state, { error }) => handleFailure(state, 'terminalStockStatusUpdate', error),
  ),
  on(TerminalOperatorManagementActions.TerminalStockStatusUpdateActions.clearState, (state) =>
    handleClear(state, 'terminalStockStatusUpdate'),
  ),

  on(TerminalOperatorManagementActions.TerminalTankUpdateActions.success, (state, { response }) =>
    handleSuccess(state, 'terminalTankUpdate', response),
  ),
  on(TerminalOperatorManagementActions.TerminalTankUpdateActions.failure, (state, { error }) =>
    handleFailure(state, 'terminalTankUpdate', error),
  ),
  on(TerminalOperatorManagementActions.TerminalTankUpdateActions.clearState, (state) =>
    handleClear(state, 'terminalTankUpdate'),
  ),

  on(TerminalOperatorManagementActions.TerminalUsageStockUpdateActions.success, (state, { response }) =>
    handleSuccess(state, 'terminalUsageStockUpdate', response),
  ),
  on(TerminalOperatorManagementActions.TerminalUsageStockUpdateActions.failure, (state, { error }) =>
    handleFailure(state, 'terminalUsageStockUpdate', error),
  ),
  on(TerminalOperatorManagementActions.TerminalUsageStockUpdateActions.clearState, (state) =>
    handleClear(state, 'terminalUsageStockUpdate'),
  ),

  on(TerminalOperatorManagementActions.CurrentDailyStockActions.success, (state, { response }) =>
    handleSuccess(state, 'currentDailyStock', response),
  ),
  on(TerminalOperatorManagementActions.CurrentDailyStockActions.failure, (state, { error }) =>
    handleFailure(state, 'currentDailyStock', error),
  ),
  on(TerminalOperatorManagementActions.CurrentDailyStockActions.clearState, (state) =>
    handleClear(state, 'currentDailyStock'),
  ),


  on(TerminalOperatorManagementActions.SubmitTerminalReportActions.success, (state, { response }) =>
    handleSuccess(state, 'submitTerminalReport', response),
  ),
  on(TerminalOperatorManagementActions.SubmitTerminalReportActions.failure, (state, { error }) =>
    handleFailure(state, 'submitTerminalReport', error),
  ),
  on(TerminalOperatorManagementActions.SubmitTerminalReportActions.clearState, (state) =>
    handleClear(state, 'submitTerminalReport'),
  ),

  on(TerminalOperatorManagementActions.UpdateTerminalStockUsageActions.request, (state) =>
    handleRequest(state, 'updateTerminalStockUsage'),
  ),
  on(TerminalOperatorManagementActions.UpdateTerminalStockUsageActions.success, (state, { response }) =>
    handleSuccess(state, 'updateTerminalStockUsage', response),
  ),
  on(TerminalOperatorManagementActions.UpdateTerminalStockUsageActions.failure, (state, { error }) =>
    handleFailure(state, 'updateTerminalStockUsage', error),
  ),
  on(TerminalOperatorManagementActions.UpdateTerminalStockUsageActions.clearState, (state) =>
    handleClear(state, 'updateTerminalStockUsage'),
  ),

  on(TerminalOperatorManagementActions.FindAllProductUnitConversionsActions.request, (state) =>
    handleRequest(state, 'findAllProductUnitConversions'),
  ),
  on(
    TerminalOperatorManagementActions.FindAllProductUnitConversionsActions.success,
    (state, { response }) => handleSuccess(state, 'findAllProductUnitConversions', response),
  ),
  on(
    TerminalOperatorManagementActions.FindAllProductUnitConversionsActions.failure,
    (state, { error }) => handleFailure(state, 'findAllProductUnitConversions', error),
  ),
  on(TerminalOperatorManagementActions.FindAllProductUnitConversionsActions.clearState, (state) =>
    handleClear(state, 'findAllProductUnitConversions'),
  ),

  on(TerminalOperatorManagementActions.DeleteTankActions.request, (state) =>
    handleRequest(state, 'deleteTank'),
  ),
  on(TerminalOperatorManagementActions.DeleteTankActions.success, (state, { response }) =>
    handleSuccess(state, 'deleteTank', response),
  ),
  on(TerminalOperatorManagementActions.DeleteTankActions.failure, (state, { error }) =>
    handleFailure(state, 'deleteTank', error),
  ),
  on(TerminalOperatorManagementActions.DeleteTankActions.clearState, (state) =>
    handleClear(state, 'deleteTank'),
  ),
);
